export default "__VITE_ASSET__208994f7__"